import RouteNode from 'route-node'
import v1 from './v1'

const studio: RouteNode = new RouteNode('', '', [
  v1
])

export default studio